import { render, staticRenderFns } from "./DDATList.vue?vue&type=template&id=0bae1aac"
import script from "./DDATList.vue?vue&type=script&lang=js"
export * from "./DDATList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports